import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ExcludedCalculationsDialogComponent } from '../excluded-calculations-dialog/excluded-calculations-dialog.component';

@Component({
  selector: 'cdba-excluded-calculations-button',
  templateUrl: './excluded-calculations-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExcludedCalculationsButtonComponent {
  @Input() numberOfUnauthorizedCalculations: number;
  @Input() missingCostRoles: string[];
  @Input() unauthorizedPlants: string[];

  private readonly dialog = inject(MatDialog);

  onOpen(): void {
    this.dialog.open(ExcludedCalculationsDialogComponent, {
      minWidth: 550,
      data: {
        numberOfUnauthorizedCalculations: this.numberOfUnauthorizedCalculations,
        missingCostRoles: this.missingCostRoles,
        unauthorizedPlants: this.unauthorizedPlants,
      },
    });
  }
}
